async function navigateTo(context, path){
    context.props.history.push(path)
}

export {
    navigateTo
}